/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientInvestmentDetailsViewModel } from './ClientInvestmentDetailsViewModel';
import {
    ClientInvestmentDetailsViewModelFromJSON,
    ClientInvestmentDetailsViewModelFromJSONTyped,
    ClientInvestmentDetailsViewModelToJSON,
} from './ClientInvestmentDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfListOfClientInvestmentDetailsViewModel
 */
export interface ResultOfListOfClientInvestmentDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfClientInvestmentDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfClientInvestmentDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfClientInvestmentDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfClientInvestmentDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfClientInvestmentDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfClientInvestmentDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfClientInvestmentDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<ClientInvestmentDetailsViewModel>}
     * @memberof ResultOfListOfClientInvestmentDetailsViewModel
     */
    data?: Array<ClientInvestmentDetailsViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfClientInvestmentDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfClientInvestmentDetailsViewModel interface.
 */
export function instanceOfResultOfListOfClientInvestmentDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfClientInvestmentDetailsViewModelFromJSON(json: any): ResultOfListOfClientInvestmentDetailsViewModel {
    return ResultOfListOfClientInvestmentDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfListOfClientInvestmentDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfClientInvestmentDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(ClientInvestmentDetailsViewModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfClientInvestmentDetailsViewModelToJSON(value?: ResultOfListOfClientInvestmentDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ClientInvestmentDetailsViewModelToJSON)),
        'Count': value.count,
    };
}

